import { useEffect, useState } from 'react';
import client from '../api/client';
import Layout from '../components/Layout';
import './AuditLog.css';

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => { loadLogs(); }, []);

  const loadLogs = async () => {
    try {
      const res = await client.get('/audit');
      setLogs(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filtered = logs.filter(l =>
    l.action.toLowerCase().includes(search.toLowerCase()) ||
    (l.user_email && l.user_email.toLowerCase().includes(search.toLowerCase()))
  );

  const actionColor = (action) => {
    if (action.includes('created')) return '#22c55e';
    if (action.includes('updated')) return '#3b82f6';
    if (action.includes('deleted')) return '#ef4444';
    if (action.includes('scanned') || action.includes('counted')) return '#f59e0b';
    return '#6b7280';
  };

  if (loading) return <Layout><div style={{color:'#6b7280', padding:'20px'}}>Loading...</div></Layout>;

  return (
    <Layout>
      <div className="audit-header">
        <h1>Audit Log</h1>
        <div className="audit-count">{logs.length} entries</div>
      </div>

      <div className="audit-search-wrap">
        <input
          className="audit-search"
          placeholder="Search by action or user..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      <div className="audit-table-wrap">
        <table className="audit-table">
          <thead>
            <tr>
              <th>Action</th>
              <th>User</th>
              <th>Entity</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr>
                <td colSpan="4" className="audit-empty">No activity yet.</td>
              </tr>
            )}
            {filtered.map(log => (
              <tr key={log.id}>
                <td>
                  <span className="audit-action" style={{ color: actionColor(log.action) }}>
                    {log.action}
                  </span>
                </td>
                <td className="audit-user">{log.user_email || '--'}</td>
                <td className="audit-entity">{log.entity_type || '--'}</td>
                <td className="audit-time">{new Date(log.created_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}